import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConnectOnStarPage } from './connect-on-star.page';

const routes: Routes = [
  {
    path: '',
    component: ConnectOnStarPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConnectOnStarPageRoutingModule {}
